import script from "./AppointmentPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentPage.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentPage.vue?vue&type=style&index=0&id=4bbed692&lang=css"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QDate,QBtnToggle,QInput,QIcon,QBtn});
